import React from "react";
import { Link } from "react-router-dom";

export const Navbar = () => {
  return (
    <>
      <nav>
        <h3>
          <Link to="/">Femi Obadimu.</Link>
        </h3>

        <div id="uc">💻</div>
      </nav>
    </>
  );
};
